import { render, staticRenderFns } from "./NsMinimalHeader.vue?vue&type=template&id=ebe88b4a&scoped=true&"
import script from "./NsMinimalHeader.vue?vue&type=script&lang=js&"
export * from "./NsMinimalHeader.vue?vue&type=script&lang=js&"
import style0 from "./NsMinimalHeader.vue?vue&type=style&index=0&id=ebe88b4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../packages/aem/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebe88b4a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/webcomponents-ui - release-finish/src/main/content/webcomponents/js/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ebe88b4a')) {
      api.createRecord('ebe88b4a', component.options)
    } else {
      api.reload('ebe88b4a', component.options)
    }
    module.hot.accept("./NsMinimalHeader.vue?vue&type=template&id=ebe88b4a&scoped=true&", function () {
      api.rerender('ebe88b4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/@nuskin/app-components/components/NsMinimalHeader.vue"
export default component.exports